// @TODO: move to component library
import {
  Toast,
  ToastClose,
  ToastContent,
  ToastDescription,
  ToastIcon,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";
import { ReactNode } from "react";
import { DialogTrigger } from "./dialog";
import { Button } from "./button";

type Props = {
  children?: ReactNode;
  setReason: (reason?: string) => boolean;
};
export function Toaster({ children, setReason }: Props) {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {children}
      {toasts.map(function ({
        id,
        description,
        reason,
        action,
        title,

        ...props
      }) {
        return (
          <Toast key={id} {...props}>
            <ToastIcon variant={props.variant} />
            <ToastContent>
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </ToastContent>
            {setReason(reason) && (
              <DialogTrigger asChild>
                <Button variant="secondary" className="ml-8">
                  See Reason
                </Button>
              </DialogTrigger>
            )}
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
